import { usedDashboard } from "../../basic/path"
import RequestModel from "../../basic/requestConfig";

export default {
    getUseCaseDashboard(vue, query) {
        return new Promise((resolve, reject) => {
            let requestModel = new RequestModel({
                    method: 'post',
                    url: usedDashboard.getUseCaseDashboard,
                    data: query.data ? query.data : {},
                    params: query.params ? query.params : {},
                    headers: {
                        'Content-Type': 'application/json;charset=UTF-8'
                    }
                }),
                request = requestModel.defaultConfig();
            vue.axios(request).then(function (result) {
                resolve(result);
            })
        });
    },
    getUseCaseOptionList(vue, query) {
        return new Promise((resolve, reject) => {
            let requestModel = new RequestModel({
                    method: 'get',
                    url: usedDashboard.getUseCaseOptionList,
                    data: query.data ? query.data : {},
                    params: query.params ? query.params : {},
                }),
                request = requestModel.defaultConfig();
            vue.axios(request).then(function (result) {
                resolve(result);
            })
        });
    },
}